module.exports = "/assets/data/89f4e0cf8de5986f50930da1f59543c7-CF61.data.json";